export default (editor, opts = {}) => {
    const sm = editor.Styles;
    const csm = opts.customStyleManager;
    const {
        width,
        height
    } = editor.Canvas.getRect();

    sm.getSectors().reset(csm && csm.length ? csm : [{
        name: 'Text',
        open: false,
        buildProps: ['font-family', 'font-weight', 'font-style', 'color', 'font-size', 'letter-spacing', 'line-height',
            'text-shadow', 'text-align', 'text-decoration'
        ],
        properties: [{
            property: 'text-shadow',
            properties: [{
                    type: 'slider',
                    name: 'X position',
                    property: 'text-shadow-h'
                },
                {
                    type: 'slider',
                    name: 'Y position',
                    property: 'text-shadow-v'
                },
                {
                    name: 'Blur',
                    property: 'text-shadow-blur',
                    type: 'slider',
                },
                {
                    name: 'Color',
                    property: 'text-shadow-color'
                }
            ],
        }, {
            type: 'slider',
            property: 'font-size',
            step: 1,
        }, {
            type: 'slider',
            property: 'letter-spacing',
            step: 1,
        }, {
            type: 'slider',
            property: 'line-height',
            step: 1,
        }, {
            property: 'font-style',
            type: 'radio',
            defaults: 'normal',
            list: [{
                    value: 'normal',
                    name: 'Normal',
                    className: 'fa fa-font'
                },
                {
                    value: 'italic',
                    name: 'Italic',
                    className: 'fa fa-italic'
                }
            ],
        }]
    }, {
        name: 'Flex',
        open: false,
        buildProps: ['flex-direction', 'flex-wrap', 'justify-content', 'align-items', 'align-content', 'order', 'flex-basis', 'flex-grow', 'flex-shrink', 'align-self']
    }, {
        name: 'Sizing',
        open: false,
        buildProps: ['width', 'min-width', 'max-width', 'float', 'height', 'min-height', 'max-height'],
        properties: [{
            type: 'slider',
            property: 'width',
            step: 1,
            max: width,
        }, {
            type: 'slider',
            property: 'min-width',
            step: 1,
            max: width,
        }, {
            type: 'slider',
            property: 'max-width',
            step: 1,
            max: width,
        }, {
            name: 'Alignment',
            property: 'float',
            type: 'radio',
            defaults: 'none',
            list: [{
                    value: 'left',
                    className: 'fa fa-long-arrow-left'
                }, {
                    value: 'none',
                    className: 'fa fa-arrows-h'
                },
                {
                    value: 'right',
                    className: 'fa fa-long-arrow-right'
                }
            ]
        }, {
            type: 'slider',
            property: 'height',
            step: 1,
            max: height,
        }, {
            type: 'slider',
            property: 'min-height',
            step: 1,
            max: height,
        }, {
            type: 'slider',
            property: 'max-height',
            step: 1,
            max: height,
        }]
    }, {
        name: 'Background',
        open: false,
        buildProps: ['background-color', 'background']
    }, {
        name: 'Scroll',
        open: false,
        buildProps: ['overflow', 'overflow-x', 'overflow-y', 'cursor'],
    }, {
        name: 'Spacing',
        open: false,
        buildProps: ['margin', 'padding'],
        properties: [{
            property: 'margin',
            properties: [{
                    name: ' ',
                    property: 'margin-top'
                },
                {
                    name: ' ',
                    property: 'margin-left'
                },
                {
                    name: ' ',
                    property: 'margin-right'
                },
                {
                    name: ' ',
                    property: 'margin-bottom'
                }
            ],
        }, {
            property: 'padding',
            properties: [{
                    name: ' ',
                    property: 'padding-top'
                },
                {
                    name: ' ',
                    property: 'padding-left'
                },
                {
                    name: ' ',
                    property: 'padding-right'
                },
                {
                    name: ' ',
                    property: 'padding-bottom'
                }
            ]
        }]
    }, {
        name: 'Border',
        open: false,
        buildProps: ['border-radius-c', 'border-radius', 'border'],
        properties: [{
            id: 'border',
            property: 'border',
            properties: [{
                id: 'border-style',
                property: 'border-style'
            }, {
                id: 'border-width',
                property: 'border-width',
                type: 'slider',
                step: 0.5
            }, {
                id: 'border-color',
                property: 'border-color',
                full: false,
            }]
        }]
    }, {
        name: 'Box-Shadow',
        open: false,
        buildProps: ['box-shadow'],
        properties: [{
            property: 'box-shadow',
            properties: [{
                    name: 'X position',
                    property: 'box-shadow-h',
                    type: 'slider',
                    min: -50
                },
                {
                    name: 'Y position',
                    property: 'box-shadow-v',
                    type: 'slider',
                    min: -50
                },
                {
                    name: 'Blur',
                    property: 'box-shadow-blur',
                    type: 'slider',
                },
                {
                    name: 'Spread',
                    property: 'box-shadow-spread',
                    type: 'slider',
                },
                {
                    name: 'Color',
                    property: 'box-shadow-color'
                },
                {
                    name: 'Shadow type',
                    property: 'box-shadow-type',
                    type: 'radio'
                }
            ]
        }]
    }, {
        name: 'Filters',
        open: false,
        buildProps: ['filter'],
    }, {
        name: 'Transform',
        open: false,
        buildProps: ['perspective', 'transform'],
    }, {
        name: 'Transitions',
        open: false,
        buildProps: ['transition'],
        properties: [{
            property: 'transition',
            properties: [{
                    name: 'Property',
                    property: 'transition-property',
                    full: true,
                },
                {
                    name: 'Easing',
                    property: 'transition-timing-function',
                    defaults: 'ease',
                    full: true,
                },
                {
                    name: 'Duration',
                    type: 'slider',
                    property: 'transition-duration',
                    step: 0.5,
                    min: 0,
                    max: 100,
                },
                {
                    name: 'Delay',
                    units: ['s'],
                    type: 'slider',
                    defaults: 0,
                    property: 'transition-delay',
                    step: 0.5,
                    min: 0,
                    max: 100,
                }
            ],
        }]
    }]);
}